import React, { Component } from 'react';
import { translate } from 'react-i18next';

class ProsaPayment extends Component {
  render() {
    var url = window.location.href + "/status";
    const { t } = this.props;
    return(

      <div className="panel panel-default">
            <div className="panel-heading">
                
            <button
                      className="btn btn-link"
                      data-target="#collapseOne"
                      data-toggle="collapse"
                      type="button">
                      VISA - MASTERCARD
                      <span className="caret" />
                    </button>               
            </div>
            <div id="collapseOne" className="panel-collapse collapse in">
                <div className="panel-body">
                <form action={url} className="paymentWidgets" data-brands="VISA MASTER"></form>
                </div>
            </div>
        </div>
    );
  }
}

export default translate('common')(ProsaPayment);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/payment/ProsaPayment.js